import moment from 'moment';
import * as Constants from './constants';
import * as DefaultStyles from './defaultStyles';
import { persistor, store } from "../../../redux/store";

// Get varialbles from local storage
export const getLocalStorageVariables = () => {
    const state = store.getState();
    const loggedInUserDetails = state.auth?.loggedInUserDetails;
    const otherUserDetails = state.auth?.otherUserDetails;
    const clientSubscriptions = state.auth?.clientSubscriptions || [];
    // let userId = typeof window !== 'undefined'?encUserDetails?JSON.parse(encUserDetails).loggedInUserId:'':'';
    // let email = typeof window !== 'undefined'?encUserDetails?JSON.parse(encUserDetails).loggedInUserEmail:'':'';
    // let accessToken = typeof window !== 'undefined'?encUserDetails?JSON.parse(encUserDetails).loggedInAccessToken:'':'';
    // let firstName = typeof window !== 'undefined'?encUserDetails?JSON.parse(encUserDetails).loggedInFirstName:'':'';
    // let lastName = typeof window !== 'undefined'?encUserDetails?JSON.parse(encUserDetails).loggedInLastName:'':'';
    // let phoneNo = typeof window !== 'undefined'?encUserDetails?JSON.parse(encUserDetails).loggedInPhoneNo:'':'';
    // let profilePic = typeof window !== 'undefined'?encUserDetails?JSON.parse(encUserDetails).loggedInProPic:'':'';
    
    // let clientSubscriptions = secureRetrieve()===undefined?[]:secureRetrieve();
    
    // let processMastersInfoFlag = typeof window !== 'undefined'?localStorage.getItem('otherUserDetails')?JSON.parse(localStorage.getItem('otherUserDetails')).processMastersInfoFlag:'':'';
    // let functionMastersInfoFlag = typeof window !== 'undefined'?localStorage.getItem('otherUserDetails')?JSON.parse(localStorage.getItem('otherUserDetails')).functionMastersInfoFlag:'':'';
    // let industryMastersInfoFlag = typeof window !== 'undefined'?localStorage.getItem('otherUserDetails')?JSON.parse(localStorage.getItem('otherUserDetails')).industryMastersInfoFlag:'':'';
    
    // let userData = {
    //     userId:userId===undefined?"":userId,
    //     email:email===undefined?"":email,
    //     accessToken:accessToken===undefined?"":accessToken,
    //     firstName:firstName===undefined?"":firstName,
    //     lastName:lastName===undefined?"":lastName,
    //     phoneNo:phoneNo===undefined?"":phoneNo,
    //     profilePic:profilePic===undefined?"":profilePic,
        
    //     clientSubscriptions:clientSubscriptions===undefined?"":clientSubscriptions,

    //     processMastersInfoFlag:processMastersInfoFlag===undefined?"":processMastersInfoFlag,
    //     functionMastersInfoFlag:functionMastersInfoFlag===undefined?"":functionMastersInfoFlag,
    //     industryMastersInfoFlag:industryMastersInfoFlag===undefined?"":industryMastersInfoFlag
    // }
    let userData = {
        userId: loggedInUserDetails?.loggedInUserId || "",
        email: loggedInUserDetails?.loggedInUserEmail || "",
        accessToken: loggedInUserDetails?.loggedInAccessToken || "",
        firstName: loggedInUserDetails?.loggedInFirstName || "",
        lastName: loggedInUserDetails?.loggedInLastName || "",
        phoneNo: loggedInUserDetails?.loggedInPhoneNo || "",
        profilePic: loggedInUserDetails?.loggedInProPic || "",
        companyLogo: loggedInUserDetails?.companyLogo || "",
        clientSubscriptions: clientSubscriptions?.clientSubscriptions || [],
        processMastersInfoFlag: otherUserDetails?.processMastersInfoFlag || "",
        functionMastersInfoFlag: otherUserDetails?.functionMastersInfoFlag || "",
        industryMastersInfoFlag: otherUserDetails?.industryMastersInfoFlag || ""
    };
    return userData;
}

export const getThemeSettingsVariables = () => {
    const state = store.getState();
    const themeSettingsData = isJsonString(state.auth?.themeSettingsData) ? JSON.parse(state.auth?.themeSettingsData) : state.auth?.themeSettingsData;

    // let themeColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).themeColor:'':'';
    // let themeTextColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).themeTextColor:'':'';
    // let themeHoverColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).themeHoverColor:'':'';
    // let themeHoverTextColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).themeHoverTextColor:'':'';

    // let sidebarBg = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarBg:'':'';
    // let sidebarBorderRight = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarBorderRight:'':'';
    // let sidebarDividerColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarDividerColor:'':'';

    // let sidebarTextColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarTextColor:'':'';
    // let sidebarIconColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarIconColor:'':'';

    // let sidebarSelectedItemBg = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarSelectedItemBg:'':'';
    // let sidebarSelectedItemTextColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarSelectedItemTextColor:'':'';
    // let sidebarSelectedItemIconColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarSelectedItemIconColor:'':'';

    // let sidebarHoverItemBg = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarHoverItemBg:'':'';
    // let sidebarHoverItemTextColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarHoverItemTextColor:'':'';
    // let sidebarHoverItemIconColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).sidebarHoverItemIconColor:'':'';

    // let topbarBg = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).topbarBg:'':'';
    // let topbarIconColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).topbarIconColor:'':'';
    // let topbarSelectedIconBg = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).topbarSelectedIconBg:'':'';
    // let notificationBadgeBg = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).notificationBadgeBg:'':'';
    // let badgeTextColor = typeof window !== 'undefined'?localStorage.getItem('themeSettings')?JSON.parse(localStorage.getItem('themeSettings')).badgeTextColor:'':'';

    // let themeSettings = {
    //     themeColor:isEmptyVariable(themeColor)?DefaultStyles.themeDefaultStyles.themeColor:themeColor,
    //     themeTextColor:isEmptyVariable(themeTextColor)?DefaultStyles.themeDefaultStyles.themeTextColor:themeTextColor,
    //     themeHoverColor:isEmptyVariable(themeHoverColor)?DefaultStyles.themeDefaultStyles.themeHoverColor:themeHoverColor,
    //     themeHoverTextColor:isEmptyVariable(themeHoverTextColor)?DefaultStyles.themeDefaultStyles.themeHoverTextColor:themeHoverTextColor,

    //     sidebarBg:isEmptyVariable(sidebarBg)?DefaultStyles.sideBarDefaultStyles.background:sidebarBg,
    //     sidebarBorderRight:isEmptyVariable(sidebarBorderRight)?DefaultStyles.sideBarDefaultStyles.borderRight:sidebarBorderRight,
    //     sidebarDividerColor:isEmptyVariable(sidebarDividerColor)?DefaultStyles.sideBarDefaultStyles.dividerColor:sidebarDividerColor,

    //     sidebarTextColor:isEmptyVariable(sidebarTextColor)?DefaultStyles.sideBarDefaultStyles.textColor:sidebarTextColor,
    //     sidebarIconColor:isEmptyVariable(sidebarIconColor)?DefaultStyles.sideBarDefaultStyles.iconColor:sidebarIconColor,

    //     sidebarSelectedItemBg:isEmptyVariable(sidebarSelectedItemBg)?DefaultStyles.sideBarDefaultStyles.selectedMenuItemBg:sidebarSelectedItemBg,
    //     sidebarSelectedItemTextColor:isEmptyVariable(sidebarSelectedItemTextColor)?DefaultStyles.sideBarDefaultStyles.selectedMenuItemTextColor:sidebarSelectedItemTextColor,
    //     sidebarSelectedItemIconColor:isEmptyVariable(sidebarSelectedItemIconColor)?DefaultStyles.sideBarDefaultStyles.selectedMenuItemIconColor:sidebarSelectedItemIconColor,

    //     sidebarHoverItemBg:isEmptyVariable(sidebarHoverItemBg)?DefaultStyles.sideBarDefaultStyles.hoverMenuItembg:sidebarHoverItemBg,
    //     sidebarHoverItemTextColor:isEmptyVariable(sidebarHoverItemTextColor)?DefaultStyles.sideBarDefaultStyles.hoverMenuItemTextColor:sidebarHoverItemTextColor,
    //     sidebarHoverItemIconColor:isEmptyVariable(sidebarHoverItemIconColor)?DefaultStyles.sideBarDefaultStyles.hoverMenuItemIconColor:sidebarHoverItemIconColor,

    //     topbarBg:isEmptyVariable(topbarBg)?DefaultStyles.topbarDefaultStyles.background:topbarBg,
    //     topbarIconColor:isEmptyVariable(topbarIconColor)?DefaultStyles.topbarDefaultStyles.iconColor:topbarIconColor,
    //     topbarSelectedIconBg:isEmptyVariable(topbarSelectedIconBg)?DefaultStyles.topbarDefaultStyles.selectedIconBgColor:topbarSelectedIconBg,
    //     notificationBadgeBg:isEmptyVariable(notificationBadgeBg)?DefaultStyles.topbarDefaultStyles.notificationBadgeBg:notificationBadgeBg,
    //     badgeTextColor:isEmptyVariable(badgeTextColor)?DefaultStyles.topbarDefaultStyles.notificationBadgeTextColor:badgeTextColor,
    // }
    let themeSettings = {
        themeColor:isEmptyVariable(themeSettingsData?.themeColor) ? DefaultStyles.themeDefaultStyles.themeColor : themeSettingsData.themeColor,
        themeTextColor:isEmptyVariable(themeSettingsData?.themeTextColor) ? DefaultStyles.themeDefaultStyles.themeTextColor : themeSettingsData.themeTextColor,
        themeHoverColor:isEmptyVariable(themeSettingsData?.themeHoverColor) ? DefaultStyles.themeDefaultStyles.themeHoverColor : themeSettingsData.themeHoverColor,
        themeHoverTextColor:isEmptyVariable(themeSettingsData?.themeHoverTextColor) ? DefaultStyles.themeDefaultStyles.themeHoverTextColor : themeSettingsData.themeHoverTextColor,

        sidebarBg:isEmptyVariable(themeSettingsData?.sidebarBg) ? DefaultStyles.sideBarDefaultStyles.background : themeSettingsData.sidebarBg,
        sidebarBorderRight:isEmptyVariable(themeSettingsData?.sidebarBorderRight) ? DefaultStyles.sideBarDefaultStyles.borderRight : themeSettingsData.sidebarBorderRight,
        sidebarDividerColor:isEmptyVariable(themeSettingsData?.sidebarDividerColor) ? DefaultStyles.sideBarDefaultStyles.dividerColor : themeSettingsData.sidebarDividerColor,

        sidebarTextColor:isEmptyVariable(themeSettingsData?.sidebarTextColor) ? DefaultStyles.sideBarDefaultStyles.textColor : themeSettingsData.sidebarTextColor,
        sidebarIconColor:isEmptyVariable(themeSettingsData?.sidebarIconColor) ? DefaultStyles.sideBarDefaultStyles.iconColor : themeSettingsData.sidebarIconColor,

        sidebarSelectedItemBg:isEmptyVariable(themeSettingsData?.sidebarSelectedItemBg) ? DefaultStyles.sideBarDefaultStyles.selectedMenuItemBg : themeSettingsData.sidebarSelectedItemBg,
        sidebarSelectedItemTextColor:isEmptyVariable(themeSettingsData?.sidebarSelectedItemTextColor) ? DefaultStyles.sideBarDefaultStyles.selectedMenuItemTextColor : themeSettingsData.sidebarSelectedItemTextColor,
        sidebarSelectedItemIconColor:isEmptyVariable(themeSettingsData?.sidebarSelectedItemIconColor) ? DefaultStyles.sideBarDefaultStyles.selectedMenuItemIconColor : themeSettingsData.sidebarSelectedItemIconColor,

        sidebarHoverItemBg:isEmptyVariable(themeSettingsData?.sidebarHoverItemBg) ? DefaultStyles.sideBarDefaultStyles.hoverMenuItembg : themeSettingsData.sidebarHoverItemBg,
        sidebarHoverItemTextColor:isEmptyVariable(themeSettingsData?.sidebarHoverItemTextColor) ? DefaultStyles.sideBarDefaultStyles.hoverMenuItemTextColor : themeSettingsData.sidebarHoverItemTextColor,
        sidebarHoverItemIconColor:isEmptyVariable(themeSettingsData?.sidebarHoverItemIconColor) ? DefaultStyles.sideBarDefaultStyles.hoverMenuItemIconColor : themeSettingsData.sidebarHoverItemIconColor,

        topbarBg:isEmptyVariable(themeSettingsData?.topbarBg) ? DefaultStyles.topbarDefaultStyles.background : themeSettingsData.topbarBg,
        topbarIconColor:isEmptyVariable(themeSettingsData?.topbarIconColor) ? DefaultStyles.topbarDefaultStyles.iconColor : themeSettingsData.topbarIconColor,
        topbarSelectedIconBg:isEmptyVariable(themeSettingsData?.topbarSelectedIconBg) ? DefaultStyles.topbarDefaultStyles.selectedIconBgColor : themeSettingsData.topbarSelectedIconBg,
        notificationBadgeBg:isEmptyVariable(themeSettingsData?.notificationBadgeBg) ? DefaultStyles.topbarDefaultStyles.notificationBadgeBg : themeSettingsData.notificationBadgeBg,
        badgeTextColor:isEmptyVariable(themeSettingsData?.badgeTextColor) ? DefaultStyles.topbarDefaultStyles.notificationBadgeTextColor : themeSettingsData.badgeTextColor,
    }
    document.body.style.setProperty("--theme-color", `rgb(${themeSettings.themeColor.r}, ${themeSettings.themeColor.g}, ${themeSettings.themeColor.b}, ${themeSettings.themeColor.a})`);
    document.body.style.setProperty("--theme-text-color", `rgb(${themeSettings.themeTextColor.r}, ${themeSettings.themeTextColor.g}, ${themeSettings.themeTextColor.b}, ${themeSettings.themeTextColor.a})`);
    return themeSettings;
}

export const getDefaultStylesObj = () => {
    let themeSettings = {
        themeColor:DefaultStyles.themeDefaultStyles.themeColor,
        themeTextColor:DefaultStyles.themeDefaultStyles.themeTextColor,
        themeHoverColor:DefaultStyles.themeDefaultStyles.themeHoverColor,
        themeHoverTextColor:DefaultStyles.themeDefaultStyles.themeHoverTextColor,

        sidebarBg:DefaultStyles.sideBarDefaultStyles.background,
        sidebarBorderRight:DefaultStyles.sideBarDefaultStyles.borderRight,
        sidebarDividerColor:DefaultStyles.sideBarDefaultStyles.dividerColor,

        sidebarTextColor:DefaultStyles.sideBarDefaultStyles.textColor,
        sidebarIconColor:DefaultStyles.sideBarDefaultStyles.iconColor,

        sidebarSelectedItemBg:DefaultStyles.sideBarDefaultStyles.selectedMenuItemBg,
        sidebarSelectedItemTextColor:DefaultStyles.sideBarDefaultStyles.selectedMenuItemTextColor,
        sidebarSelectedItemIconColor:DefaultStyles.sideBarDefaultStyles.selectedMenuItemIconColor,

        sidebarHoverItemBg:DefaultStyles.sideBarDefaultStyles.hoverMenuItembg,
        sidebarHoverItemTextColor:DefaultStyles.sideBarDefaultStyles.hoverMenuItemTextColor,
        sidebarHoverItemIconColor:DefaultStyles.sideBarDefaultStyles.hoverMenuItemIconColor,

        topbarBg:DefaultStyles.topbarDefaultStyles.background,
        topbarIconColor:DefaultStyles.topbarDefaultStyles.iconColor,
        topbarSelectedIconBg:DefaultStyles.topbarDefaultStyles.selectedIconBgColor,
        notificationBadgeBg:DefaultStyles.topbarDefaultStyles.notificationBadgeBg,
        badgeTextColor:DefaultStyles.topbarDefaultStyles.notificationBadgeTextColor,
    }
    return themeSettings;
}
//Check Variable is empty
export const isEmptyVariable = (variableName) => {
    if(variableName === ''){
        return true;
    }
        
    if(variableName === undefined){
        return true;
    }

    if(variableName === null){
        return true;
    }

    if(variableName === "null"){
        return true;
    }
    
    return false;
}

//Check if array is empty
export const isEmptyArray = (arrayName) => {
    if(arrayName === ''){
        return true;
    }
        
    if(arrayName === undefined){
        return true;
    }

    if(arrayName === null){
        return true;
    }

    if(!Array.isArray(arrayName)){
        return true;
    }

    if(arrayName.length === 0){
        return true;
    }
    
    return false;
}

export const ifEmptyReturnEmptyStr = (variableName, EmptyStr) => {
    return isEmptyVariable(variableName)?EmptyStr:variableName;
}

export const ifEmptyReturn = (variableName) => {
    return isEmptyVariable(variableName)?"":variableName;
}

export const removeHtmlTags = (htmlStr) => {
    return htmlStr?.replace(/(<([^>]+)>)/gi, "")
                    ?.replace(/&nbsp;/gi, " ")
                    ?.replace(/&nbsp;/gi, " ")     // replace &nbsp; with space
                    ?.replace(/&amp;/gi, "&")      // optional: replace other common entities
                    ?.replace(/&lt;/gi, "<")
                    ?.replace(/&gt;/gi, ">")
                    ?.replace(/&quot;/gi, '"')
                    ?.replace(/&#39;/gi, "'");
}

export const getTrimmedText = (text, wordLimit = 10) => {
  if (isEmptyVariable(text)) return "";
  const words = text.trim().split(/\s+/);
  if (words.length <= wordLimit) {
    return words.join(' ');
  }
  return words.slice(0, wordLimit).join(' ') + '...';
}
export const sortTable = (sortColumn, currentSortColumn, currentSortDir) => {

    let sortObj = {
        sortDirTemp:"",
        sortTemp:sortColumn
    };
    
    //if the clicked column is same as previously clicked column
    //then just change the sorting direction
    //if it is different then change the column param to new & reinitialise sortdir to asc 
    if(currentSortColumn === sortColumn){
        if(currentSortDir === ""){
            sortObj.sortDirTemp = "asc";
        }else if(currentSortDir === "asc"){
            sortObj.sortDirTemp = "desc";
        }else if(currentSortDir === "desc"){
            sortObj.sortDirTemp = "";
            sortObj.sortTemp="";
        }
    }else{
        sortObj.sortDirTemp = "asc";
    }

    return sortObj;
}

export const sortTableTwoStates = (sortColumn, currentSortColumn, currentSortDir) => {

    let sortObj = {
        sortDirTemp:"",
        sortTemp:sortColumn
    };

    //if the clicked column is same as previously clicked column
    //then just change the sorting direction
    //if it is different then change the column param to new & reinitialise sortdir to asc 
    if(currentSortColumn === sortColumn){
        if(currentSortDir === ""){
            sortObj.sortDirTemp = "asc";
        }else if(currentSortDir === "asc"){
            sortObj.sortDirTemp = "desc";
        }else if(currentSortDir === "desc"){
            //Go back to default setting
            sortObj.sortDirTemp = "asc";
        }
    }else{
        sortObj.sortDirTemp = "asc";
    }

    return sortObj;
}

export const validatePassword = (password) =>{
    let respObj = {
        err:false,
        responseMsg:""
    }

    // password empty
    if(isEmptyVariable(password)){
        respObj = {
            err:true,
            responseMsg:"Please enter password"
        }
        return respObj;
    }
    // // confirm password empty
    // if(isEmptyVariable(confirmPassword)){
    //     respObj = {
    //         err:true,
    //         responseMsg:"Please enter confirm password."
    //     }
    //     return respObj;
    // }
    // Rule 1: Minimum 8 characters
    if(password.length < 8) {
        respObj = {
            err:true,
            responseMsg:"Password must be at least 8 characters long."
        }
        return respObj;
    }

    // Rule 2: At least one uppercase letter
    if (!/[A-Z]/.test(password)) {
         respObj = {
            err:true,
            responseMsg:"Password must contain at least one uppercase letter (A-Z)."
        }
        return respObj;
    }

    // Rule 3: At least one lowercase letter
    if (!/[a-z]/.test(password)) {
        respObj = {
            err:true,
            responseMsg:"Password must contain at least one lowercase letter (a-z)."
        }
        return respObj;
    }

    // Rule 4: At least one number
    if (!/\d/.test(password)) {
        respObj = {
            err:true,
            responseMsg:"Password must contain at least one number (0-9)."
        }
        return respObj;
    }

    // Rule 5: At least one special character (@$!%*?&)
    if (!/[@$!%*?&]/.test(password)) {
        respObj = {
            err:true,
            responseMsg:"Password must contain at least one special character (@, $, !, %, *, ?, &)."
        }
        return respObj;
    }
    
    // Rule 6: Confirm password check (if provided)
    // if (confirmPassword !== null && password !== confirmPassword) {
    //     respObj = {
    //         err:true,
    //         responseMsg:"Password and confirm password do not match."
    //     }
    //     return respObj;
    // }
    return respObj;
}

export const truncateString = (str, num) => {
    
    if(isEmptyVariable(str)){
        return "-";
    }

    if(str.length <= num){
        return str;
    }

    if(str.length > num){
        return str.substring(0,num) + "...";
    }
}

export const truncateStringV2 = (str, num) => {
    
    if(isEmptyVariable(str)){
        return "";
    }

    if(str.length <= num){
        return str;
    }

    if(str.length > num){
        return str.substring(0,num) + "...";
    }
}

//PROJECT SPECIFIC FUNCTIONS
export const SplitJoinString = (str, splitParam1, splitParam2,joinParam,pos) => {
    // alert(str)
    let resArr = [];
    let position = pos;
    if(isEmptyVariable(pos)){
        position = 0;
    }
    if(isEmptyVariable(str)) return "";

    let splitArr = str.split(splitParam1);

    if(isEmptyArray(splitArr)) return "";

    splitArr.map((item)=>{
        resArr.push(item.split(splitParam2)[position])
    })

    return resArr.join(joinParam);
        
}
export const DoubleSplitString = (str, splitParam1, splitParam2,pos) => {
    // alert(str)
    let resArr = [];
    let position = pos;
    if(isEmptyVariable(pos)){
        position = 0;
    }
    if(isEmptyVariable(str)) return "";

    let splitArr = str.split(splitParam1);

    if(isEmptyArray(splitArr)) return "";

    splitArr.map((item)=>{
        resArr.push(item.split(splitParam2)[position])
    })

    return resArr;
        
}

export const GetOrderedMasterTabMenuTask = (menusTemp) => {
    let menusTemp2 = {};

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_TASKS]) &&
    menusTemp[Constants.SCREEN_TASKS] !== "NONE"){
        menusTemp2[Constants.SCREEN_TASKS] = menusTemp[Constants.SCREEN_TASKS];
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_CHECKLIST]) &&
    menusTemp[Constants.SCREEN_CHECKLIST] !== "NONE"){
        menusTemp2[Constants.SCREEN_CHECKLIST] = menusTemp[Constants.SCREEN_CHECKLIST];
    }

    return menusTemp2;
}
export const GetOrderedMasterTabMenuExecutes = (menusTemp) => {
    let menusTemp2 = {};

    // if((!isEmptyVariable(menusTemp[Constants.SCREEN_EXECUTE]) &&
    // menusTemp[Constants.SCREEN_EXECUTE] !== "NONE")){
        // menusTemp2["Execute"] = "Execute";
        // menusTemp2["Follow Up"] = "Follow Up";
        if((!isEmptyVariable(menusTemp[Constants.SCREEN_EXECUTE]) && 
            menusTemp[Constants.SCREEN_EXECUTE] === 1))
        {
            menusTemp2[Constants.SCREEN_EXECUTE] = menusTemp[Constants.SCREEN_EXECUTE];
        }
        if((!isEmptyVariable(menusTemp[Constants.SCREEN_FOLLOW_UP]) &&
            menusTemp[Constants.SCREEN_FOLLOW_UP] === 1))
        {
            menusTemp2[Constants.SCREEN_FOLLOW_UP] = menusTemp[Constants.SCREEN_FOLLOW_UP];
        }
    // }

    return menusTemp2;
}

export const GetOrderedMasterTabMenuExecute = (menusTemp,obsTemplateId,isSampleChecked,assignmentLevelTemplateId) => {
    let menusTemp2 = {};

    if((!isEmptyVariable(menusTemp[Constants.SCREEN_EXECUTE]) &&
    menusTemp[Constants.SCREEN_EXECUTE] === 1)){
        menusTemp2["Tasks"] = "Tasks";
        if(hasFeatureAccess(Constants.FEATURE_OBSERVATION) && !isEmptyVariable(obsTemplateId)){
            menusTemp2["Observations"] = "Observations";
        }
        if(!isEmptyVariable(assignmentLevelTemplateId) 
        // && !isEmptyVariable(menusTemp['Assignment Level Template']) && menusTemp["Assignment Level Template"] !== "NONE"
    ) {
            menusTemp2['Assignment Level Template'] = menusTemp['Assignment Level Template'];
        }
        if(isSampleChecked){
            menusTemp2["Doc List"] = "Doc List";
        }
        menusTemp2["Working Papers"] = "Working Papers";
        menusTemp2["Auditee"] = "Auditee";
        menusTemp2["Timeline"] = "Timeline";

        // For display completed tab
        if((!isEmptyVariable(menusTemp[Constants.SCREEN_COMPLETED_REPORTS]) &&
        menusTemp[Constants.SCREEN_COMPLETED_REPORTS] === "VIEW")){
            menusTemp2["Completed Reports"] = "Completed";
        }
    }

    return menusTemp2;
}

export const GetOrderedMasterTabMenuReports = (menusTemp) => {
    let menusTemp2 = {};

    if((!isEmptyVariable(menusTemp[Constants.SCREEN_REPORT]) &&
    menusTemp[Constants.SCREEN_REPORT] !== "NONE")){
        menusTemp2["Ongoing"] = "Ongoing";
        menusTemp2["Draft"] = "Draft";
    }
    if((!isEmptyVariable(menusTemp[Constants.SCREEN_COMPLETED_REPORTS]) &&
    menusTemp[Constants.SCREEN_COMPLETED_REPORTS] === "VIEW")){
        menusTemp2["Completed Reports"] = "Completed";
    }
    return menusTemp2;
}

export const GetOrderedMasterTabMenuPlanning = (menusTemp) => {
    let menusTemp2 = {};

    if((!isEmptyVariable(menusTemp[Constants.SCREEN_SCHEDULED_ASSIGNMENT_ALL]) &&
    menusTemp[Constants.SCREEN_SCHEDULED_ASSIGNMENT_ALL] !== "NONE") ||
    (!isEmptyVariable(menusTemp[Constants.SCREEN_SCHEDULED_ASSIGNMENT_MANAGERS]) &&
    menusTemp[Constants.SCREEN_SCHEDULED_ASSIGNMENT_MANAGERS] !== "NONE")
    ){
        menusTemp2[Constants.SCREEN_SCHEDULED_ASSIGNMENT_ALL] = menusTemp[Constants.SCREEN_SCHEDULED_ASSIGNMENT_ALL];
    }

    if((!isEmptyVariable(menusTemp[Constants.SCREEN_PLAN_ASSIGNMENT_ALL]) &&
    menusTemp[Constants.SCREEN_PLAN_ASSIGNMENT_ALL] !== "NONE") ||
    (!isEmptyVariable(menusTemp[Constants.SCREEN_PLAN_ASSIGNMENT_MANAGERS]) &&
    menusTemp[Constants.SCREEN_PLAN_ASSIGNMENT_MANAGERS] !== "NONE")
    ){
        menusTemp2[Constants.SCREEN_PLAN_ASSIGNMENT_ALL] = menusTemp[Constants.SCREEN_PLAN_ASSIGNMENT_ALL];
    }

    if((!isEmptyVariable(menusTemp[Constants.SCREEN_FOLLOW_UP]) &&
    menusTemp[Constants.SCREEN_FOLLOW_UP] === 1)
    ){
        menusTemp2[Constants.SCREEN_FOLLOW_UP] = menusTemp[Constants.SCREEN_FOLLOW_UP];
    }
    return menusTemp2;
}

export const GetOrderedMasterTabMenu = (menusTemp) => {
    let menusTemp2 = {};

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_PROCESS]) &&
    menusTemp[Constants.SCREEN_PROCESS] !== "NONE"){
        menusTemp2[Constants.SCREEN_PROCESS] = menusTemp[Constants.SCREEN_PROCESS];
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_FUNCTION]) &&
    menusTemp[Constants.SCREEN_FUNCTION] !== "NONE"){
        menusTemp2[Constants.SCREEN_FUNCTION] = menusTemp[Constants.SCREEN_FUNCTION];
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_INDUSTRY]) &&
    menusTemp[Constants.SCREEN_INDUSTRY] !== "NONE"){
        menusTemp2[Constants.SCREEN_INDUSTRY] = menusTemp[Constants.SCREEN_INDUSTRY];
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_DOCUMENT]) &&
    menusTemp[Constants.SCREEN_DOCUMENT] !== "NONE"){
        menusTemp2[Constants.SCREEN_DOCUMENT] = menusTemp[Constants.SCREEN_DOCUMENT];
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_RISK]) &&
    menusTemp[Constants.SCREEN_RISK] !== "NONE"){
        menusTemp2[Constants.SCREEN_RISK] = menusTemp[Constants.SCREEN_RISK];
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_OTHER]) &&
    menusTemp[Constants.SCREEN_OTHER] !== "NONE"){
        menusTemp2[Constants.SCREEN_OTHER] = menusTemp[Constants.SCREEN_OTHER];
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_GENERAL]) &&
    menusTemp[Constants.SCREEN_GENERAL] !== "NONE"){
        menusTemp2[Constants.SCREEN_GENERAL] = menusTemp[Constants.SCREEN_GENERAL];
    }

    return menusTemp2;
}
export const GetSidebarTemplateLink = (menusTemp) => {
    if(!isEmptyVariable(menusTemp["Task Template"]) &&
    menusTemp["Task Template"] !== "NONE"){
        return Constants.URL_TASK_TEMPLATES;
    }
    
    if(!isEmptyVariable(menusTemp["Execution Template"]) &&
    menusTemp["Execution Template"] !== "NONE"){
        return Constants.URL_EXECUTE_TASK_TEMPLATES;
    }

    if(hasFeatureAccess(Constants.FEATURE_OBSERVATION) && !isEmptyVariable(menusTemp["Observation Template"]) &&
    menusTemp["Observation Template"] !== "NONE"){
        return Constants.URL_OBSERVATION_TEMPLATES;
    }
    
    if(!isEmptyVariable(menusTemp["Follow Up Template"]) &&
    menusTemp["Follow Up Template"] !== "NONE"){
        return Constants.URL_FOLLOWUP_TEMPLATES;
    }
}
export const GetSidebarMasterLink = (menusTemp) => {

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_PROCESS]) &&
    menusTemp[Constants.SCREEN_PROCESS] !== "NONE"){
        return Constants.URL_PROCESSES;
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_FUNCTION]) &&
    menusTemp[Constants.SCREEN_FUNCTION] !== "NONE"){
        return Constants.URL_FUNCTIONS;
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_INDUSTRY]) &&
    menusTemp[Constants.SCREEN_INDUSTRY] !== "NONE"){
        return Constants.URL_INDUSTRIES;
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_DOCUMENT]) &&
    menusTemp[Constants.SCREEN_DOCUMENT] !== "NONE"){
        return Constants.URL_DOCUMENTS;
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_RISK]) &&
    menusTemp[Constants.SCREEN_RISK] !== "NONE"){
        return Constants.URL_RISK;
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_OTHER]) &&
    menusTemp[Constants.SCREEN_OTHER] !== "NONE"){
        return Constants.URL_OTHERMASTERS;
    }

    if(!isEmptyVariable(menusTemp[Constants.SCREEN_GENERAL]) &&
    menusTemp[Constants.SCREEN_GENERAL] !== "NONE"){
        return Constants.URL_GENERALMASTERS;
    }

    return "";
}
export const GetSidebarSettingLink = (menusTemp) => {
    if(!isEmptyVariable(menusTemp['Client Settings']) &&
    menusTemp["Client Settings"] !== "NONE"){
        return Constants.URL_CLIENT_SETTINGS;
    }
    if(!isEmptyVariable(menusTemp['Department Settings']) &&
    menusTemp["Department Settings"] !== "NONE"){
        return Constants.URL_DEPARTMENT_SETTINGS;
    }
    return Constants.URL_ASSIGNMENT_TYPE_SETTINGS;
}
export const GetTemplateTabMenu = (menusTemp) => {
    let menuObj = {};
    if(!isEmptyVariable(menusTemp['Task Template']) &&
    menusTemp["Task Template"] !== "NONE"){
        menuObj['Task Template'] = menusTemp['Task Template'];
    }
    if(!isEmptyVariable(menusTemp['Execution Template']) &&
    menusTemp["Execution Template"] !== "NONE"){
        menuObj['Execution Template'] = menusTemp['Execution Template'];
    }
    if(hasFeatureAccess(Constants.FEATURE_OBSERVATION) && !isEmptyVariable(menusTemp['Observation Template']) &&
    menusTemp["Observation Template"] !== "NONE"){
        menuObj['Observation Template'] = menusTemp['Observation Template'];
    }
    if(!isEmptyVariable(menusTemp['Assignment Level Template']) &&
    menusTemp["Assignment Level Template"] !== "NONE"){
        menuObj['Assignment Level Template'] = menusTemp['Assignment Level Template'];
    }
    if(!isEmptyVariable(menusTemp['Follow Up Template']) &&
    menusTemp["Follow Up Template"] !== "NONE"){
        menuObj['Follow Up Template'] = menusTemp['Follow Up Template'];
    } 
    if(!isEmptyVariable(menusTemp['Response Template']) &&
    menusTemp["Response Template"] !== "NONE"){
        menuObj['Response Template'] = menusTemp['Response Template'];
    }
    return menuObj;
}

export const getOnlyFileNameFromPath = (path) => {
    if(isEmptyVariable(path)){
        return "";
    }

    return path.split("_-_").pop();
}

export const rgb2hex = (rgb) => {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? "#" +
     ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
     ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
     ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
   }

export const isJsonString = (str) => {
    try{
        JSON.parse(str)
    }catch(e){
        return false;
    }
    return true;
}

export const getStringWithSpaceAfterComma = (str) => {
    let resStr = "";
    if(isEmptyVariable(str)){
        return "";
    }
    resStr = str.split(",").join(", ");
    return resStr;
}

export const isNumber = (num) => {
    return (typeof(num) === 'number' || typeof(num) === 'string' && num.trim() !== '') && !isNaN(num);
}

export const isAlphaNumericCharacter = (str) =>{

    let pattern =/^[^\`"':]+$/i;
    return pattern.test(str);

}

export const isValidEmail = (email) => {
    let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    return pattern.test(email);
}


export const getStatusSpan = (previousStatus, themeSettings) => {
    // alert(previousStatus);
    let spanText = "";
    let spanStyle = {
        background:"#f5f5f5",
        color:"#000"
    }
    if(previousStatus === "Updated"){
        spanText = "Updated";
        spanStyle = {
            background:"#ddd",
            color:"#000"
        }
    }else if(previousStatus === "Created"){
        spanText = "New";
        spanStyle = {
            background:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b})`,
            color:`rgba(${themeSettings.themeTextColor.r},${themeSettings.themeTextColor.g},${themeSettings.themeTextColor.b},${themeSettings.themeTextColor.a})`
        }
    }else if(previousStatus === "Inactive"){
        spanText = "Deleted";
        spanStyle = {
            background:"#ff0000",
            color:"#fff"
        }
    }else if(previousStatus === "Deleted"){
        spanText = "Deleted";
        spanStyle = {
            background:"#ff0000",
            color:"#fff"
        }
    }

    return {
        spanText:spanText,
        spanStyle:spanStyle,
    }
}

export const getClientResponseDeadlineBadge = (clientResponseDeadline) => {
    if(isEmptyVariable(clientResponseDeadline)) return null;

    const deadline = moment(clientResponseDeadline).startOf('day');
    const daysLeft = deadline.diff(moment().startOf('day'), 'days');

    let bgColor = "";
    let textColor = "";
    let relativeText = "";

    if(daysLeft < 0){
        bgColor = "#fdecea";
        textColor = "#c62828";
        let overdueDays = Math.abs(daysLeft);
        relativeText = `Overdue by ${overdueDays} day${overdueDays === 1 ? "" : "s"}`;
    }else if(daysLeft === 0){
        bgColor = "#e3f2fd";
        textColor = "#1565c0";
        relativeText = "Due today";
    }else{
        bgColor = "#e8f5e9";
        textColor = "#2e7d32";
        relativeText = `${daysLeft} days left to respond`;
    }

    return {
        text: deadline.format("DD MMM YYYY"),
        bgColor,
        textColor,
        tooltip: `${relativeText}`,
    };
}

export const getRechartXAxisLabel = (text, index) => {
    const maxChar = 10;
    if (text.length > maxChar) {
        text = text.slice(0, maxChar) + "...";
    }
    return text;
}
export const getRechartYAxisLabel = (text, index) => {

    return text +"%";
}
export const compareObjects = (obj1, obj2) => {
    const keys = Object.keys(obj1);
    for (let key of keys) {
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    return true;
}

export const handleTokenExpiry = (responseCode) => {
    if (
        responseCode === Constants.CODE_ACCESS_TOKEN_INVALID ||
        responseCode === Constants.CODE_ACCESS_TOKEN_EXPIRED
    ) {
        // if (typeof logoutFn === "function") {
        //     logoutFn();
        // }
        // this.props.logout();
        persistor.purge();
        localStorage.clear();
        window.location = "/";
        return true; // Indicates redirect happened
    }
    return false; // No redirect, continue normal flow
};
export const hasFeatureAccess = (featureName) => {
    if (!featureName) return false;

    try {
        const state = store.getState();
        const clientSubscriptions = state.auth?.clientSubscriptions || [];
        if (!Array.isArray(clientSubscriptions)) {
            return false;
        }
        return clientSubscriptions?.some(menu =>
            menu.subMenuList?.some(sub =>
                sub.featureList?.some(f => 
                    f.featureName === featureName && f.hasRights === "Y"
                )
            )
        );
    } catch (error) {
        return false;
    }
};
export const removeEmojis = (text) => {
	return text.replace(emojiRegex, '');
}
export const containsEmoji = (text) => {
	return emojiRegex.test(text);
}
export const emojiRegex = /([\u203C-\u3299]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\u200D|\uFE0F)/g;

export const isFormDirty = (initialValues, currentValues, fieldsToCheck) => {
    return fieldsToCheck.some(field => initialValues[field] !== currentValues[field]);
}
export const validateFile = async (file, isProfile) => {
    // Extension check
    if (!(isProfile===true?Constants.PROFILE_ALLOWED_EXTENSIONS:Constants.DOC_ALLOWED_EXTENSIONS).test(file.name)) {
        return { valid: false, message: isProfile?Constants.PROFILE_ERROR_MESSAGE:Constants.DOC_ERROR_MESSAGE};
    }

    // MIME type check
    if (!(isProfile===true?Constants.ALL_IMAGE_TYPE_MIME:Constants.ALL_ALLOWED_MIME_TYPES).includes(file.type)) {
        return { valid: false, message: 'Invalid image type.' };
    }

    // Magic bytes check
    const arrayBuffer = await file.slice(0, 4).arrayBuffer();
    const header = Array.from(new Uint8Array(arrayBuffer));
    
    // Extract file extension (without the dot, lowercase)
    const ext = file.name.split('.').pop().toLowerCase();
    let checkSignature = isProfile===true?Constants.PROFILE_SIGNATURE[ext]:Constants.FILE_SIGNATURES[ext];
    if (checkSignature) {
        const expectedSig = checkSignature;
        const bytesToCheck = expectedSig.length;

        const isMatch = header.slice(0, bytesToCheck).toString() === expectedSig.toString();
        if (!isMatch) {
            return { valid: false, message: 'Selected file type is not permissible for upload' };
        }else {
            // If we have no magic signature defined for this extension, skip magic check
            // console.warn(`No magic signature defined for .${ext}, skipping magic number validation.`);
        }
    }

    // Size check
    const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    if (sizeInMB > (isProfile===true?Constants.VALID_PROFILE_IMAGE_SIZE:Constants.MAX_DOCUMENT_MASTER_FILE_SIZE)) {
        if(isProfile === true){
            return { valid: false, message: Constants.PROFILE_SIZE_ERROR_MESSAGE};
        }else{
             return { valid: false, message: Constants.DOCUMENT_FILE_SIZE};
        }
    }

    return { valid: true };
};
// Function to encrypt data
export const encryptPassword = async (publicKey, password) => {
    // const publicKey = await importPublicKey(publicKeyPem);
    const encodedPassword = new TextEncoder().encode(password);
    
    const encrypted = await crypto.subtle.encrypt(
        {name: "RSA-OAEP"},
        publicKey,
        encodedPassword
    );
    
    // Return as a Base64 string to send to the server
    return window.btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}

// 🔑 Import PEM public key into Web Crypto
export const importPublicKey = async (pem) => {
    // Remove PEM header/footer and newlines
    const pemHeader = "-----BEGIN PUBLIC KEY-----";
    const pemFooter = "-----END PUBLIC KEY-----";
    const pemContents = pem.replace(pemHeader, "").replace(pemFooter, "").replace(/\s/g, "");
    const binaryDer = window.atob(pemContents);
    const binaryArray = new Uint8Array(binaryDer.length);
    for (let i = 0; i < binaryDer.length; i++) {
        binaryArray[i] = binaryDer.charCodeAt(i);
    }
    return await window.crypto.subtle.importKey(
        "spki",               // Public key format
        binaryArray.buffer,   // Key bytes
        {
            name: "RSA-OAEP",
            hash: "SHA-256"
        },
        true,
        ["encrypt"]
    );
};
export const leadingTrailingSpaceRemove = (rawString) => {
  if (!rawString) return '';
  
  // 1. Trim the *outside* whitespace (the space you highlighted)
  let cleaned = rawString.trim(); 
  
  // 2. Remove the leading and trailing <p> tags
  cleaned = cleaned.replace('<p>', '').replace('</p>', '');
  
  // 3. Trim any remaining *inside* whitespace that was next to the tags
  cleaned = cleaned.trim(); 
  
  return cleaned;
};
export const getSettingStatus = (settings, key, expectedStatus, departmentId, assignmentTypeId, matchAssignmentType = true, templateId, matchTemplate = false) => {
    return settings.some(e => {
        return(
            e.settingColumn.includes(key) &&
            e.settingColumnEnabled === expectedStatus &&
            e.departmentId === departmentId &&
            (!matchAssignmentType || e.assignmentTypeId === assignmentTypeId) &&
            (!matchTemplate || e.rootTemplateId === templateId)
        )
    });
};
